var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMVacaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_vacaciones"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vacaciones"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.69 54.98 51.3 50.37 50.62 48.38 45.68 53.32 46.69 54.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.49 14.56 10.88 19.17 12.72 20.28 17.69 15.31 15.49 14.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.27,35.09l2.59,1,4.93-4.93-14.89-9L.28,32.72a.4.4,0,0,0,0,.56l5,5a12.41,12.41,0,0,1,8.22-3.92A12,12,0,0,1,18.27,35.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.08,45.46h0l-4.2-1.57L15,48A4.53,4.53,0,0,1,15.08,45.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72l-12-12a26.17,26.17,0,0,1-2.2,2.51l-3.93,3.93,1.4,1.4,2.2,2.2,1.49,1.49a.4.4,0,0,1,0,.56l-1.49,1.49-.43.43.56.56,2.2,2.2L55,39a.39.39,0,0,1,0,.56l-1.48,1.49-2.08,2.08,1.13,3.28L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.8,45l1,2.58a11.92,11.92,0,0,1-3.05,12.89l-.13.12,5.13,5.13a.4.4,0,0,0,.56,0L43.86,55.14,34.73,40.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.4,50.77A4.69,4.69,0,0,1,19,51a4.08,4.08,0,0,1-1.16-.18L22,55l-1.57-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.81,12.32l1.48-1.49a.42.42,0,0,1,.57,0l1.49,1.49,2.2,2.2.56.56.43-.43L33,13.16a.4.4,0,0,1,.57,0l1.49,1.49,2.2,2.2,1.4,1.4,3.92-3.93a29,29,0,0,1,2.51-2.21L33.28.28a.4.4,0,0,0-.56,0L19.66,13.34l3.07,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.67,59.51l1.1,2.94a.4.4,0,0,0,.65.15l2.17-2L22,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.3,50.37,46.69,55l-1-1.66-1.82,1.82.69,1.13,1.39,2.29a.4.4,0,0,0,.62.08l1.9-1.9,4.6-4.6.93-.93a.39.39,0,0,0,.09-.41l-.42-1.24-1.07-3.15-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.14,38.41l-1.89,2a.4.4,0,0,0,.16.65l2.93,1.09,4.54,1.7L5.27,38.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.69,49.39a4,4,0,0,0,2.13,1.43L15,48A4,4,0,0,0,15.69,49.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.58,10.41a1.87,1.87,0,0,1,.56-.09,1.41,1.41,0,0,1,1.31,2h0A22.6,22.6,0,0,1,52,19l1.78,1.78A24.87,24.87,0,0,0,57.83,13a4,4,0,0,0-.54-3.65,3.85,3.85,0,0,0-3.15-1.57A4.28,4.28,0,0,0,52.82,8a25.22,25.22,0,0,0-7.71,4.08L46.9,13.9A22.6,22.6,0,0,1,53.58,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.88,19.17l4.61-4.61,2.2.75,2-2L16.3,12.2l-1.24-.43a.39.39,0,0,0-.41.1l-.93.92L9.11,17.4,7.22,19.29a.4.4,0,0,0,.08.63l2.28,1.39,1.32.79,1.82-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.21,36.05l-8.32,8.31,1.53,4.1A9.39,9.39,0,0,1,26,58.64L22,47.82c-.65.16-1.41.32-2.41.6h0a2.38,2.38,0,0,1-.58.08,1.62,1.62,0,0,1-1.54-2.2h0c.28-1,.43-1.76.6-2.41l-10.82-4A9.43,9.43,0,0,1,17.4,37.43L21.49,39l8.32-8.31L12.72,20.28,10.9,22.1l14.89,9-4.93,4.93-2.59-1a12,12,0,0,0-4.78-.74,12.41,12.41,0,0,0-8.22,3.92l5.61,5.61,4.2,1.57h0A4.53,4.53,0,0,0,15,48l2.81,2.81A4.08,4.08,0,0,0,19,51a4.69,4.69,0,0,0,1.42-.23h0L22,55l5.61,5.61.13-.12a11.92,11.92,0,0,0,3.05-12.89L29.8,45l4.93-4.93,9.13,15.07,1.82-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.54,41.05,55,39.56A.39.39,0,0,0,55,39l-1.48-1.49-2.2-2.2-.56-.56.43-.43,1.49-1.49a.4.4,0,0,0,0-.56l-1.49-1.49L49,28.58l-1.4-1.4,3.93-3.93a26.17,26.17,0,0,0,2.2-2.51L52,19a26.11,26.11,0,0,1-2.19,2.53l-6.22,6.22,1.61,4.72,2.08-2.08,2.2,2.2-3.16,3.16,1.19,3.47,2.1-2.1,2.2,2.2-3.18,3.18,2,5.92,2-2-1.13-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.4,17.27l3.18-3.18,2.2,2.2-2.1,2.1,3.47,1.18,3.16-3.16,2.2,2.21L33.43,20.7l4.72,1.61,6.22-6.22A22.83,22.83,0,0,1,46.9,13.9l-1.79-1.79a29,29,0,0,0-2.51,2.21l-3.92,3.93-1.4-1.4-2.2-2.2-1.49-1.49a.4.4,0,0,0-.57,0l-1.48,1.49-.43.43-.56-.56-2.2-2.2-1.49-1.49a.42.42,0,0,0-.57,0l-1.48,1.49L22.73,14.4l-3.07-1.06-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.3,50.37l-2.71-7.91,3.18-3.18-2.2-2.2-2.1,2.1-1.19-3.47,3.16-3.16-2.2-2.2-2.08,2.08-1.61-4.72,6.22-6.22a23.17,23.17,0,0,0,5.68-9.21h0a1.43,1.43,0,0,0-1.87-1.87h0a23,23,0,0,0-9.21,5.68l-6.22,6.22L33.43,20.7l2.08-2.08-2.2-2.21-3.16,3.16-3.47-1.18,2.1-2.1-2.2-2.2L23.4,17.27l-7.91-2.71-4.61,4.61L29.81,30.65,21.49,39,17.4,37.43A9.4,9.4,0,0,0,7.22,39.84l10.82,4c-.17.65-.32,1.41-.6,2.41h0a1.65,1.65,0,0,0,2.12,2.12h0c1-.28,1.76-.44,2.41-.6L26,58.64a9.41,9.41,0,0,0,2.4-10.18l-1.53-4.1,8.32-8.31L46.69,55Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMVacaciones);
export default __webpack_public_path__ + "static/media/m_vacaciones.5887e567bba602c963d297970f183a66.svg";
export { ForwardRef as ReactComponent };